import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { MuiPickersUtilsProvider } from "@material-ui/pickers"; // for Material-ui-pickers
import DateFnsUtils from "@date-io/date-fns"; // date util library
import store from "./redux/store"; // importing the redux store
import { Provider } from "react-redux";
import axios from "axios";
import { BrowserRouter } from "react-router-dom";
import { createMuiTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import { Colors } from "./helpers/Colors";
import { Toaster } from "react-hot-toast";
// import "./app/Home/google1898c1088f3e2adc.html";
const LocalURL = "http://localhost:5000/";
// const CloudURL =
//   "https://node-cors-proxy-mercy.herokuapp.com/https://cabins-backend.herokuapp.com/";
// const CloudURL = "https://r-cabins-b.vercel.app/";

// axios.defaults.baseURL = CloudURL;

const defaultMaterialTheme = createMuiTheme({
  palette: {
    primary: {
      main: Colors.primary,
    },
    secondary: {
      main: Colors.secondary,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <MuiPickersUtilsProvider utils={DateFnsUtils}>
    <Provider store={store}>
      <BrowserRouter>
        <ThemeProvider theme={defaultMaterialTheme}>
          <Toaster />
          <App />
        </ThemeProvider>
      </BrowserRouter>
    </Provider>
  </MuiPickersUtilsProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
